import React from 'react';
import Breadcrumbs from './Breadcrumbs';

export default function PageHeading(props) {
  const {breadcrumbs = [], title, subhead, description, children} = props;

  return (
    <div className="space-y-2">
      <Breadcrumbs breadcrumbs={breadcrumbs}/>
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <div className="text-4xl font-semibold text-base-content">
            {title}
          </div>
          {subhead && (
            <div className="mt-2 font-semibold text-2xl leading-6 text-base-content">
              {subhead}
            </div>
          )}
          {description && (
            <div className="mt-2 max-w-4xl text-sm text-base-content/70">
              {description}
            </div>
          )}
        </div>
        {children}
      </div>
    </div>
  );
}
